<template>
  <v-btn
    v-add-zuko-tag
    v-bind="{ ...$attrs, ...$props }"
    v-on="$listeners"
  >
    <slot />
    <template
      v-if="$slots.loader"
      #loader
    >
      <slot name="loader" />
    </template>
  </v-btn>
</template>

<script>
export default {
  name: 'qz-btn',
};
</script>
